export default {
  1: {
    'id': 1,
    'name': 'Cappucinno',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': true,
    'type': 'simple',
    'price': 8,
    'currency': 'lei'
  },
  2: {
    'id': 2,
    'name': 'Latte Machiato',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': true,
    'type': 'simple',
    'price': 7.50,
    'currency': 'lei'
  },
  3: {
    'id': 3,
    'name': 'Chocolate Cookie ',
    'image_url': 'http://placeholder.pics/svg/60/DEDEDE/8F8F8F-DEDEDE/image',
    'active': false,
    'type': 'combo',
    'price': 10.20,
    'currency': 'lei'
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Products/products.js